import React from 'react';

import PropTypes from 'prop-types';

import { TOAST_POSITION, TOAST_TYPE } from './constants';

import '@hotmart/cosmos/dist/alert';
import '@hotmart/cosmos/dist/toast';
import ToastUtils from '@hotmart/cosmos/dist/toast/utils';
import { sanitize } from '@hotmart/devsec-toolkit';

import './toast.scss';

const Toast = () => {
  return document.querySelector('hot-toast') ? null : <hot-toast />;
};

const defaultPosition = TOAST_POSITION.TOP_RIGHT;

const buildToastPayload = ({ message, position = defaultPosition }) => ({
  message: sanitize({
    html: message
  }),
  position,
  dismissible: false
});

Toast[TOAST_TYPE.danger] = (props) => {
  ToastUtils[TOAST_TYPE.danger](buildToastPayload(props));
};

Toast.error = Toast[TOAST_TYPE.danger];

Toast[TOAST_TYPE.info] = (props) => {
  ToastUtils[TOAST_TYPE.info](buildToastPayload(props));
};

Toast[TOAST_TYPE.success] = (props) => {
  ToastUtils[TOAST_TYPE.success](buildToastPayload(props));
};

Toast[TOAST_TYPE.warning] = (props) => {
  ToastUtils[TOAST_TYPE.warning](buildToastPayload(props));
};

Toast.propTypes = {
  message: PropTypes.string,
  position: PropTypes.string
};

export default Toast;
